import * as z from "zod";

export const editUserDetailsSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
});

export type EditUserDetailsFormData = z.infer<typeof editUserDetailsSchema>;
